import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import i1 from "../../assets/serviceimages/1.1.jpeg";
import i2 from "../../assets/serviceimages/1.2.jpeg";
import i3 from "../../assets/serviceimages/1.3.jpeg";
import i4 from "../../assets/serviceimages/2.1.jpeg";
import i5 from "../../assets/serviceimages/2.2.jpeg";
import i6 from "../../assets/serviceimages/2.3.jpeg";
import i7 from "../../assets/serviceimages/3.1.jpeg";
import i8 from "../../assets/serviceimages/3.2.jpeg";
import i9 from "../../assets/serviceimages/3.3.jpeg";

// Per-column image sets
const images1 = [i1, i2, i3]; // 1.x
const images2 = [i4, i5, i6]; // 2.x
const images3 = [i7, i8, i9]; // 3.x

// helper: group images into chunks
const chunkArray = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) result.push(arr.slice(i, i + size));
  return result;
};

const Services = () => {
  return (
    <div className="flex flex-col md:flex-row" id="services">
      {/* First column: 1 per slide (1.1, 1.2, 1.3) */}
      <div className="flex-1">
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={4000}
          showStatus={false}
          className="w-full h-full"
        >
          {images1.map((img, idx) => (
            <div key={idx}>
              <img src={img} alt={`Series 1 — ${idx + 1}`} className="w-full h-full object-cover" />
            </div>
          ))}
        </Carousel>
      </div>

      {/* Second column: 2 per slide (2.1, 2.2, 2.3) */}
      <div className="flex-1">
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={4000}
          showStatus={false}
          className="w-full h-full"
        >
         {images2.map((img, idx) => (
            <div key={idx}>
              <img src={img} alt={`Series 2 — ${idx + 1}`} className="w-full h-full object-cover" />
            </div>
          ))}
        </Carousel>
      </div>

      {/* Third column: 3 per slide (3.1, 3.2, 3.3) */}
      <div className="flex-1">
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={4000}
          showStatus={false}
          className="w-full h-full"
        >
          {images3.map((img, idx) => (
            <div key={idx}>
              <img src={img} alt={`Series 3 — ${idx + 1}`} className="w-full h-full object-cover" />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Services;
